<template>
    <section
        v-editable="blok"
        class="tours-overview"
    >
        <KSectionHeader
            v-if="title || blok.eyebrow || blok.text"
            class="tours-overview__header"
            :eyebrow="blok.eyebrow"
            :text="blok.text"
            :align="blok.align || 'start'"
        >
            <template
                v-if="title"
                #title
            >
                <span v-html="title" />
            </template>
            <template
                v-if="blok.action_label && (blok.action_link?.url || blok.action_link?.email || blok.action_link?.cached_url || blok.action_link?.anchor)"
                #actions
            >
                <StoryblokSectionHeaderAction
                    :label="blok.action_label"
                    :link="blok.action_link"
                    placement="tours-overview"
                />
            </template>
        </KSectionHeader>

        <p
            v-if="pending && !tours.length"
            class="tours-overview__status"
        >
            Loading tours...
        </p>
        <p
            v-else-if="error"
            class="tours-overview__status tours-overview__status--error"
        >
            Tours could not be loaded. Please try again later.
        </p>
        <p
            v-else-if="!tours.length"
            class="tours-overview__status"
        >
            No tours are available at the moment.
        </p>
        <div
            v-else
            class="tours-overview__grid"
        >
            <TourCard
                v-for="tour in tours"
                :key="tour.uuid"
                :tour="tour"
                :detail="blok.detail"
                @select="track(tour, $event)"
            />
        </div>
    </section>
</template>

<script setup>
import { KSectionHeader } from '@vemedia/karibu'
import TourCard from '~/components/tour-card/tour-card.vue'
import renderHighlightedText from '~/helpers/renderHighlightedText'

const { blok } = defineProps(['blok'])
const { capture } = useTracking()

const title = computed(() => {
    if (!blok.title?.content?.length)
        return ''
    const document = { ...blok.title, content: blok.title.content.map(node => ({ ...node })) }
    return renderHighlightedText(document)
})

const { data: tours, error, pending } = await useAsyncData(
    `tours-overview-${blok._uid}`,
    () => $fetch('/api/tours'),
    { default: () => [] },
)

function track(tour, action) {
    capture('tour_overview_clicked', {
        placement: 'tours-overview',
        target_slug: tour.full_slug,
        action,
    })
}
</script>

<style lang="scss">
@use 'tours-overview';
</style>
